<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('nav.teams')"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="$t('team.editBreadcrumb')"
      :title="$t('team.editBreadcrumb')"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>

          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>

        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import userApi from "~/api/user";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";

export default {
  name: "TeamCreate",
  metaInfo: {
    title: "Team Create",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
      },
      data: null,
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.TEAM_LIST.replace(":page", 1);
    },
    getId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.getItem();
  },
  methods: {
    handleSubmit() {
      const url = `/${this.getId}`;
      const data = {
        name: this.formDataToSend.name,
      };

      this.$store.dispatch("users/editTeam", { url: url, editData: data });
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.TEAM_LIST.replace(":page", 1),
      });
    },
    getItem() {
      const url = `/${this.getId}?with[0]=groups`;
      try {
        userApi.getItemTeam(url).then((res) => {
          this.$store.commit("users/setError", {});
          this.$store.commit("users/setValidationErrors", {});
          const data = res.data;
          this.data = data;
          this.formDataToSend.name = data.name;
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
.item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr 2fr 1fr;
  padding: 10px 15px;
  margin-bottom: 10px;
  background: gainsboro;
  border-radius: 10px;
}
.item-button {
  padding: 10px;
  border-radius: 10px;
  background: #3c2a1e;
  color: #fff;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}
.list-items {
  padding-top: 30px;
}
.list-items__title {
  padding: 20px 0;
  font-size: 24px;
  font-weight: 700;
}
</style>
